module.exports = __webpack_public_path__ + "img/bionic-logo-light.8896c10f.svg";